import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--gtag-custom-event-on-support-modal"
export default class extends Controller {
  static targets = ["checkbox"];
  connect() {}

  conditionalSend() {
    if (this.checkboxTargets.some((el) => el.checked)) {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ event: "career_support_conversion" });
      return false;
    }
  }
}
